import { render, staticRenderFns } from "./TermVetExpress.vue?vue&type=template&id=62736f29&scoped=true"
import script from "./TermVetExpress.vue?vue&type=script&lang=js"
export * from "./TermVetExpress.vue?vue&type=script&lang=js"
import style0 from "./TermVetExpress.vue?vue&type=style&index=0&id=62736f29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62736f29",
  null
  
)

export default component.exports